import { render, staticRenderFns } from "./FormConfirmButton.vue?vue&type=template&id=d1d71e5a"
import script from "./FormConfirmButton.vue?vue&type=script&lang=js"
export * from "./FormConfirmButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports